.root {
  box-sizing: border-box;
  background-color: white;
  font-family:
    -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu',
    'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  line-height: 1.2;
  color: #020402;
}

.root {
  --primary: #c0da74;
  --primary-light: #d4e09b;
  --primary-lighter: #eaf0cd;
  --primary-dark: #9aae5d;
  --primary-bg: #f5fbef;
  --primary-light-bg: #fafdf7;
  --primary-dark-bg: #dde2d7;
  --secondary: #8cdfc7;
  --secondary-light: #b7fcf3;
  --secondary-lighter: #dbfef9;
  --secondary-dark: #1b998b;
  --secondary-dark-15: #1b998b26;
  --secondary-darker: #0e5846;
  --secondary-bg: #d9f4ec;
  --secondary-light-bg: #ecfaf6;
  --toolbar-height: 2.875rem;
  --toolbarBtn-height: 2rem;
}

.root {
  --h5w-info--color: var(--secondary-dark);
  --h5w-matrix-cell--bgColorAlt: var(--secondary-light-bg);
  --h5w-matrix-indexCell--bgColor: var(--primary-bg);
  --h5w-matrix-indexCell--bgColorAlt: var(--primary-light-bg);
  --h5w-matrix-anchorCell--bgColor: var(--primary-dark-bg);
  --h5w-btn--height: var(--toolbarBtn-height);
  --h5w-btn-hover--bgColor: var(--secondary-lighter);
  --h5w-btnPressed--bgColor: var(--secondary-light);
  --h5w-toolbar--height: var(--toolbar-height);
  --h5w-toolbar--bgColor: var(--secondary-light-bg);
  --h5w-toolbar-label--color: var(--secondary-dark);
  --h5w-toolbar-input-focus--shadowColor: var(--secondary-dark);
  --h5w-domainSlider-track--bgColor: var(--secondary-dark-15);
  --h5w-domainSlider-dataTrack--bgColor: var(--secondary-dark);
  --h5w-domainSlider-dataTrack--shadowColor: var(--secondary-darker);
  --h5w-domainSlider-thumb--bgColor: var(--secondary);
  --h5w-domainSlider-thumb-auto--bgColor: var(--secondary-light);
  --h5w-domainControls-boundInput-focus--shadowColor: var(--secondary-dark);
  --h5w-domainControls-boundInput-editing--borderColor: var(--secondary-dark);
  --h5w-selector-option-hover--bgColor: var(--secondary-light-bg);
  --h5w-selector-option-selected--bgColor: var(--secondary-light);
  --h5w-histogram--color: var(--secondary-dark);
  --h5w-histogram-marker--color: var(--secondary-darker);
  --h5w-interactionHelp-shortcut--bgColor: var(--primary-light);
  --h5w-dimMapper--bgColor: var(--primary-light-bg);
  --h5w-slicingSlider-bounds--color: var(--secondary-darker);
  --h5w-slicingSlider-track--color: var(--secondary-dark);
  --h5w-slicingSlider-thumb--borderColor: var(--secondary);
  --h5w-slicingSlider-thumb--bgColor: var(--primary-bg);
}

:where(.root) *,
:where(.root) *::before,
:where(.root) *::after {
  box-sizing: inherit;
}

@media (min-width: 50em) {
  .root {
    font-size: 1.125rem;
  }
}

@media (prefers-color-scheme: dark) {
  .root[data-allow-dark-mode] {
    filter: invert();

    /* Set shadows to lighter colors so they remain dark once inverted */
    --h5w-btnRaised--shadowColor: #f5f5f5;
    --h5w-btnRaised-hover--shadowColor: #fff;
    --h5w-domainSlider-track--shadowColor: #f5f5f5;
    --h5w-domainSlider-dataTrack--shadowColor: #fff;

    /* Change line colors for better contrast once inverted */
    --h5w-line--color: deepskyblue;
    --h5w-line--colorAux: orange, lightgreen, red, violet, gold;
  }

  .root[data-allow-dark-mode] [data-keep-colors],
  .root[data-allow-dark-mode] [data-keep-canvas-colors] canvas {
    filter: invert(); /* invert back to normal colors */
  }
}

@media (prefers-reduced-motion) {
  .root *,
  .root *::before,
  .root *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

.sidebarArea {
  display: flex;
  flex-direction: column;
  background-color: var(--primary-bg);
  overflow-x: hidden;
  overflow-y: auto;
}

.root[data-sidebar-collapsed] .sidebarArea {
  display: none;
}

.splitter {
  position: relative;
  z-index: 1;
  width: 2px;
  background-color: #ddd;
}

.splitter:focus {
  outline: none;
}

.splitter::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: -2px;
  width: 6px;
  background-color: #ddd;
  transition: opacity 0.1s ease-in-out;
  cursor: ew-resize;
  opacity: 0;
}

.splitter:not([data-separator='inactive'])::before,
.splitter:hover::before /* splitter becomes "inactive" after resizing even if still hovered */ {
  opacity: 1;
  transition-delay: 0.3s; /* delay showing (but not hiding) */
}

.splitter:focus-visible::before {
  opacity: 1;
}

.mainArea {
  display: flex;
  flex-direction: column;
}

.fallbackBar {
  flex: none;
  height: var(--toolbar-height);
  background-color: var(--secondary-light-bg);
}

.fallbackBar[data-mode='inspect'] {
  background-color: var(--primary-bg);
}

.fallback {
  composes: fallback from './utils.module.css';
}

.error {
  composes: error from './utils.module.css';
  grid-area: vis;
}

.error > span {
  margin-left: 0.5rem;
}

.detailedError {
  composes: error from './utils.module.css';
  overflow: auto;
  scrollbar-width: thin;
}

.detailedError > summary {
  cursor: pointer;
}

.detailedError > pre {
  font-size: 0.875em;
}

.retryBtn {
  composes: btnLink from './utils.module.css';
}
